// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XwLJFl30oMWIgr {
  width: 48%;
  margin-bottom: var(--ds-space-200, 16px);
}
.XwLJFl30oMWIgr:first-child {
  /* stylelint-disable-next-line design-system/ensure-design-token-usage -- (spacing) */
  margin-right: 4%;
}
`, ""]);
// Exports
export var button = `XwLJFl30oMWIgr`;
export default ___CSS_LOADER_EXPORT___;
